





































import Component, { mixins } from "vue-class-component";
import axios from "@/plugins/axios";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class Consolidation extends mixins(ErrorMixin) {
  public dates = [
    new Date().toISOString().substr(0, 10),
    new Date().toISOString().substr(0, 10),
  ];

  public DoConso() {
    this.$store.dispatch("login/setLoading", true);

    if (this.dates[0] > this.dates[1]) {
      const temp = this.dates[0];
      this.dates[0] = this.dates[1];
      this.dates[1] = temp;
    }

    const startDate = new Date(this.dates[0]);
    const exportDates = [];

    if (this.dates.length > 1 && this.dates[1] !== this.dates[0]) {
      const endDate = new Date(this.dates[1]);
      const dateToExport = new Date(startDate);

      while (dateToExport <= endDate) {
        exportDates.push(dateToExport.toISOString().substr(0, 10));
        dateToExport.setDate(dateToExport.getDate() + 1);
      }
    } else {
      exportDates.push(startDate.toISOString().substr(0, 10));
    }

    const promises = exportDates.map((date) => {
      const url = "consolidation/emission?dateFiscale=" + date;
      return axios.get(url);
    });

    Promise.all(promises)
      .then((responses) => {
        responses.forEach((response: any) => {
          if (response.data.code === 2) {
            this.setSuccess("Consolidation OK");
          } else {
            console.log(response.data.response);
            const err = response.data.response[0].message
              ? response.data.response[0].message.toString()
              : response.data.response;
            this.setErrorFromTxt(err);
          }
        });
        this.$store.dispatch("login/setLoading", false);
      })
      .catch((error) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.$store.dispatch("login/setLoading", false);
      });
  }
}
